import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=2b49909c"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=2b49909c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports